import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sectionIndex } from '../../features/dashboard/SectionTwoSlice';
import { sectionStore } from '../../features/dashboard/SectionThreeSlice';
import Header from './Header';
import Input from '../form/Input';
import Select from '../form/Select';
import Button from '../form/Button';
import Loading from '../../Loading';
import { ToastContainer, toast } from 'react-toastify';

function ArchiveSectionThree () {

    // Define Some Variable On This Page
    const dispatch = useDispatch();
    const [status, setStatus] = useState(false)
    const [loading, setLoading] = useState(true)
    const [sectionTwo, setSectionTwo] = useState('')
    const [title, setTitle] = useState('')
    // Define Variable From SectionTwo Slice
    let {
        archiveSectionThreeLoading,
        archiveSectionThreeSuccess,
        message,
        errorSectionTwo,
        errorTitle,
    } = useSelector((state) => state.sectionThree)
    const {sections} = useSelector(state => state.sectionTwo)
    
    useEffect(() => {
        // Handle Loading page Before Load DOM
        status === true ? setLoading(true) : setLoading(false)
        
        dispatch(sectionIndex(localStorage.getItem('token')));
        // Logic Spinner Loading Page After Store Data
        if(archiveSectionThreeSuccess === true && status === true) {
            toast.success(message,{
                position: "top-center",
                autoClose: 600,
              })
            setStatus(false)
            setLoading(false)
            setTitle('')
            setSectionTwo('')
            message = ''
        }
        console.log(loading)
        return () => {
            
            // Handle Loading page Before Load DOM
            // Fetch Archive Section Two For The Load Option on Select Box
            
        }
        
    },[loading,archiveSectionThreeSuccess])

    // Submit Form Data to ArchiveSectionThree Slice
    const sectionThreeHandler = (event) => {
        event.preventDefault();
        setLoading(true)
        setStatus(true)
        const data = {
            'section_two_id': sectionTwo,
            'title': title
        }
        // Dispatch Data to Method SectionStore of ArchiveSectionThree Slice
        dispatch(sectionStore(data));
    }
    return (
        <>
        { loading ? (<Loading />) : null }
        <form className="text-end">
            <div className='row g-2 p-5 my-5'>
                <Header title={'ثبت بخش های انبار - بخش پایانی'} />  
                <div className="col-6 ">
                    <Select
                        key='1'
                        tab='1'
                        col='col-12'
                        name='section_two_id'
                        title='انتخاب بخش میانی'
                        value={sectionTwo}
                        errorName={errorSectionTwo}
                        onchange={(e) => setSectionTwo(e.target.value)}
                        status='1'
                        data={sections}
                        focus='1'
                    />
                </div>
                <div className="col-6 ">
                    <Input 
                        key='2'
                        tab='2'
                        col='col-12'
                        type='text'
                        maxlength={255}
                        name='title'
                        value={title}
                        title='عنوان'
                        onchange={(e) => setTitle(e.target.value)}
                        placeholder='مانند : ساختمان کویر موتور' 
                        errorName={errorTitle}
                    />   
                </div>
                <div className="row g-2 px-0 mt-4 mb-0">
                    <div className="row mx-1 d-grid gap-2 col-6 col-md-3 me-auto">
                        <Button 
                            tab='3'
                            title='ثبت بخش پایانی'
                            design="position-relative px-4 py-1 btn btn-dark fw-bold"
                            event={sectionThreeHandler}
                        />
                    </div>
                </div>
            </div>
        </form>
        </>
    )
}

export default ArchiveSectionThree;